import { useEffect, useState } from "react";

const inputClass =
  "mt-1 block w-full rounded-xl border border-slate-300 bg-white px-3.5 py-2.5 text-sm text-slate-900 shadow-sm outline-none transition focus:border-amber-500 focus:ring-2 focus:ring-amber-500/20";

const AboutPhotoSection = ({
  formData,
  updateField,
}) => {
  const [photoPreview, setPhotoPreview] =
    useState("");

  const count =
    String(
      formData.aboutBrideGroom || ""
    ).length;

  useEffect(() => {
    const selectedPhoto =
      formData.photo;

    if (
      !selectedPhoto ||
      typeof File === "undefined" ||
      !(selectedPhoto instanceof File)
    ) {
      setPhotoPreview("");
      return undefined;
    }

    const objectUrl =
      URL.createObjectURL(
        selectedPhoto
      );

    setPhotoPreview(objectUrl);

    return () => {
      URL.revokeObjectURL(
        objectUrl
      );
    };
  }, [formData.photo]);

  return (
    <div className="space-y-6">
      <label className="block text-sm font-medium text-slate-700">
        About Yourself
        <span className="ml-1 text-red-600">*</span>
        <textarea
          name="aboutBrideGroom"
          value={
            formData.aboutBrideGroom ||
            ""
          }
          onChange={updateField}
          maxLength={1000}
          rows={6}
          className={inputClass}
          placeholder="Tell prospective families about yourself, your interests, values and expectations."
        />
        <div className="mt-1.5 flex justify-between text-xs">
          <span
            className={
              count < 50
                ? "text-amber-700"
                : "text-emerald-700"
            }
          >
            Minimum 50 characters
          </span>
          <span className="text-slate-500">
            {count}/1000
          </span>
        </div>
      </label>

      <label className="block text-sm font-medium text-slate-700">
        Profile Photo
        <input
          type="file"
          name="photo"
          accept="image/*"
          onChange={updateField}
          className={inputClass}
        />
      </label>

      {photoPreview && (
        <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
          <p className="mb-3 text-sm font-medium text-slate-700">
            Photo Preview
          </p>

          <img
            src={photoPreview}
            alt="Selected profile preview"
            className="h-40 w-40 rounded-xl border border-slate-200 bg-white object-cover shadow-sm"
          />
        </div>
      )}
    </div>
  );
};

export default AboutPhotoSection;
